import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=cb7f1b74&scoped=true"
import script from "./BaseWidget.vue?vue&type=script&lang=ts"
export * from "./BaseWidget.vue?vue&type=script&lang=ts"
import style0 from "./BaseWidget.vue?vue&type=style&index=0&id=cb7f1b74&prod&lang=scss&scoped=true"
import style1 from "./BaseWidget.vue?vue&type=style&index=1&id=cb7f1b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7f1b74",
  null
  
)

export default component.exports